import { render } from "./RehabitAni.vue?vue&type=template&id=4fc1886f&scoped=true"
import script from "./RehabitAni.vue?vue&type=script&lang=js"
export * from "./RehabitAni.vue?vue&type=script&lang=js"

import "./RehabitAni.vue?vue&type=style&index=0&id=4fc1886f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4fc1886f"

export default script